import { render, staticRenderFns } from "./PostulantNewUser.vue?vue&type=template&id=bd021418&scoped=true&"
import script from "./PostulantNewUser.vue?vue&type=script&lang=js&"
export * from "./PostulantNewUser.vue?vue&type=script&lang=js&"
import style0 from "./PostulantNewUser.vue?vue&type=style&index=0&id=bd021418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd021418",
  null
  
)

export default component.exports